<script setup>

import { inject, onMounted, reactive, ref} from 'vue';
import Modal from '../Modal.vue';
import { getAuth } from 'firebase/auth';
import { Firebase_App } from '../firebase.js';
import { db, getDocumentById, getDocumentsWithPrefix } from '../firestore.js';
import Button from '../components/Button.vue';
import { collection, getDocs, limit, orderBy, query, startAfter, where } from 'firebase/firestore';
import ScrollIntoView from './ScrollIntoView.vue';


const emit = defineEmits(['close']);


const activeDoc = inject('document')
const userInfo = inject('userInfo')
const threads = ref([])
const loading = ref(false)

let lastVisible = null;

async function loadNext() {

  try {
    loading.value = true

    const constr = [
      collection(db, 'AgentMemory'),
      where('owner', "==", userInfo.uid),
      where('groupKey', '==', activeDoc.value.id),
      orderBy("created", 'desc'),
      limit(10),
      // select('title'),    
    ]

    if (lastVisible) {
      constr.push(startAfter(lastVisible))      
    }
    
    const q = query(
      ...constr
    );    

    const snapshot = await getDocs(q);

    threads.value = [
      ...threads.value,
      ...snapshot.docs.map(doc => ({
        id: doc.id,
        title: doc.data().title,
        created: doc.data().created
      }))
    ]
    if (snapshot.docs.length) {
      const last = snapshot.docs[snapshot.docs.length - 1]
      if (last.id !== lastVisible?.id) {
        lastVisible = last
      }
    }

  } finally {
    loading.value = false
  }
}


onMounted(async () => {

  await loadNext()

})

function setThread(id) {
  activeDoc.value.activeThreadId = id;
  emit('close')
}

function renderTime(timestamp) {
  const date = new Date(timestamp);

  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

</script>

<template>

<Modal @close="() => emit('close')" title="History of Your AI Chats">  
  <div class="a-flex-1 a-scrollable" >
    <ul class="text-sm">
      <li @click="setThread(t.id)" v-for="t in threads" class="selectable item">
        <ScrollIntoView v-if="t.id === lastVisible.id">
          {{t.title}} 
        </ScrollIntoView>
        <div v-else>{{t.title}}</div>
        <span class="text-base-content/50"> {{renderTime(t.created)}}</span>
        
      </li>
    </ul>
  </div>
  <div v-if="loading">Loading...</div>
  <div v-else><button @click="loadNext" class="btn btn-sm">Load More...</button></div>
</Modal>  

  
</template>


<style scoped>

</style>